import {
    graphql
} from 'react-relay'


const query = graphql`
    query getAllAccountQuery ($pagination: PaginationInput, $sorts: [OrderInput!], $where: JSON) {
        getAllAccount (pagination: $pagination, sorts: $sorts, where: $where) {
            count,
            items {
                id
                name
                createdAt
                updatedAt
            }
      }
    }
  `

  export default query;